<template>
    <div style="height: 100%">
        <LeftNavBar
            :title="selectedAppInitial"
            :drag="false"
            :hasChild="false"
            :items="sidebarItems"
            @opened="onChange"
            :selectedValue="sidebarSelection"
        />
    </div>
</template>

<script>
import LeftNavBar from "bh-mod/components/common/LeftNavBar";
export default {
    components: {LeftNavBar },
    name: "menu-left",
    data() {
        return {
            openID: "",
        };
    },
    computed: {
		selectedAppInitial() {
			return this.$store.state.theApp?.media?.initial || "AI";
		},
        sidebarItems() {
            let items = [
                {
                    label: "Agents",
                    value: "Agents",
                    iconUrl: require("@/assets/sideIcons/AI.svg"),
                },
				{
                    label: "Knowledge Base",
                    value: "Knowledge Base",
                    iconUrl: require("@/assets/sideIcons/knowledgeBase.svg"),
                },
				{
                    label: "Call History",
                    value: "Call History",
                    iconUrl: require("@/assets/sideIcons/callHistory.svg"),
                },
                {
                    divider: true,
                },
                {
                    label: "Settings",
                    value: "Settings",
                    iconUrl: require("@/assets/sideIcons/settings.svg"),
                },
            ];

			if(!this.$store.getters.isAIAdvanceAddOn) {
				items.splice(2, 1);
			}
            return items;
        },
		sidebarSelection() {
			return this.$store.state.sidebarSelection;
		},
    },
    methods: {
        onChange(data) {
            if (data.value) {
                if (data.value === "Settings" && this.$route.path !== "/settings") {
                    this.$router.push(`/settings`);
                } else if (data.value === "Knowledge Base" && this.$route.path !== "/knowledgeBase") {
                    this.$router.push(`/knowledgeBase`);
                } else if (data.value === "Call History" && this.$route.path !== "/call-history" && this.$store.getters.isAIAdvanceAddOn) {
                    this.$router.push(`/call-history`);
                } else if (this.$route.path !== "/") {
                    this.$router.push(`/`);
                }
            }
            return;
        }
    },
};
</script>
